export const lightTheme = {
    body: '#FFF',
    text: '#363537',
    toggleBorder: 'black',
    background: '#363537',
    buttontext:'white',
}
export const darkTheme = {
    body: '#1A1A2E',
    text: '#E94560',
    toggleBorder: 'white',
    background: 'black',
    buttontext:'#F9D276',
}
